import { render } from "./ServiceListPage.vue?vue&type=template&id=962144a2&ts=true"
import script from "./ServiceListPage.vue?vue&type=script&lang=ts"
export * from "./ServiceListPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dedee/dedee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__